import * as DialogPrimitive from "@radix-ui/react-dialog";
import clsx from "clsx";
import { forwardRef } from "react";
import styled from "styled-components";

import { Icon } from "@/components/ui-deprecated";
import styles from "@/components/ui-deprecated/Dialog/Dialog.module.css";

type DialogWidth = "xd" | "sm" | "md" | "lg";

const widthMap: Record<DialogWidth, number> = {
    xd: 320,
    sm: 480,
    md: 800,
    lg: 1200,
};

const DialogPrimitiveContentStyled = styled(DialogPrimitive.Content)<
    DialogPrimitive.DialogContentProps & React.RefAttributes<HTMLDivElement> & { $width?: number }
>`
    ${({ $width }) => ($width ? `min-width: ${$width}px;` : "")}
`;

const DialogContent = forwardRef<
    React.ElementRef<typeof DialogPrimitive.Content>,
    React.ComponentPropsWithoutRef<typeof DialogPrimitiveContentStyled> & { width?: DialogWidth }
>((props, ref) => {
    const { className, children, width, ...otherProps } = props;

    return (
        <DialogPrimitive.Portal>
            <DialogPrimitive.Overlay className={styles.dialog_overlay}>
                <DialogPrimitiveContentStyled
                    $width={widthMap[width!]}
                    {...otherProps}
                    ref={ref}
                    className={clsx(className, styles.dialog_content)}
                >
                    {children}
                    <DialogPrimitive.Close className={styles.dialog_close}>
                        <Icon icon={"times"} className={styles.dialog_close_icon} />
                    </DialogPrimitive.Close>
                </DialogPrimitiveContentStyled>
            </DialogPrimitive.Overlay>
        </DialogPrimitive.Portal>
    );
});
DialogContent.displayName = DialogPrimitive.Content.displayName;

export { DialogContent };
export type { DialogWidth };
